import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import ProductPublishEditor from '@/tiktok-platform/modules/products/ProductPublishEditor';

/** 编辑商品：优先本地草稿 / 发布记录 / 商品缓存，再回落平台 Get Product */
export default function ProductEditPage() {
  const { spuName: spuFromPath } = useParams();
  const [params] = useSearchParams();
  const spuName = decodeURIComponent(spuFromPath || params.get('spu') || '');
  const recordId = params.get('recordId') || '';
  const draftId = params.get('draftId') || '';

  return (
    <ProductPublishEditor
      mode="edit"
      spuName={spuName}
      recordId={recordId}
      draftId={draftId}
    />
  );
}
